export const OVERLAY_ID = 'drawer-overlay';
export const BODY_ID = 'drawer-body';
export const BODY_INNER_ID = 'drawer-body-inner-wrapper';
export const CLOSE_ID = 'drawer-close';
